import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const CardsIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.39054 2H7.8116C6.6537 2 5.70633 2.94737 5.70633 4.10526V10.8421L9.39054 2ZM3.70634 3.68421L2.33792 4.31579C1.28528 4.73684 0.758967 6 1.18002 7.05263L3.70634 13.2632V3.68421ZM5.91686 16L11.18 3.36842C11.4958 2.52632 12.2327 2.10526 13.0748 2.10526C13.3905 2.10526 13.6011 2.21053 13.9169 2.31579L21.7063 5.47368C22.759 5.89474 23.2853 7.05263 22.759 8.10526L17.4958 20.7368C17.18 21.5789 16.4432 22 15.6011 22C15.2853 22 15.0748 22 14.759 21.7895L6.96949 18.6316C6.12739 18.3158 5.70633 17.5789 5.70633 16.7368C5.8116 16.5263 5.8116 16.2105 5.91686 16ZM12.8642 15.4737L16.2327 12.9474L15.8116 8.73684L12.4432 11.2632L12.8642 15.4737Z"
      fill={color}
    />
  </svg>
);
